<template>
  <div
    v-if="preview.enabled && preview.renderData"
    class="sf-layer-white sf-layer-rounded sf-pad-3 sf-below-2 sf-align-c"
  >
    <div v-if="preview.renderData" ref="graph" class="report-graph" />
  </div>

  <div
    v-else-if="preview.enabled && !preview.renderData"
    class="sf-layer-rounded sf-bg-snow-dark sf-pad-5 sf-level-items"
  >
    <div
      class="sf-layer-rounded sf-bg-white sf-pad-4 sf-layer-shadow sf-align-c"
    >
      <div v-if="saving" class="sf-level sf-level-around">
        <div class="sf-spinner sf-spinner-s" />
      </div>
      <div v-else>
        <div class="sf-font-l sf-font-bold sf-below-3 sf-title">
          {{ I18n.t('js.report_graph.edit.save_for_preview_info') }}
        </div>
        <button
          class="sf-btn sf-btn-success"
          data-walkthrough-id="chart-save-and-preview"
          @click="saveGraph()"
        >
          {{ I18n.t('js.report_graph.edit.save_and_preview') }}
        </button>
      </div>
    </div>
  </div>

  <div
    v-else-if="!preview.enabled"
    class="
      sf-layer-rounded
      sf-bg-snow-dark
      sf-pad-5
      sf-below-2
      sf-align-c
      sf-font-s
      sf-font-medium
    "
  >
    {{ I18n.t('js.report_graph.edit.no_preview_available_info') }}
  </div>
</template>

<script>
import { nextTick } from 'vue'
import { mapState, mapActions } from 'vuex'
import buildGraph from '../../../handlers/build-graph'

export default {
  name: 'SfPreview',
  computed: {
    ...mapState(['preview', 'saving']),
  },
  watch: {
    'preview.renderData': function (value, oldValue) {
      if (value !== oldValue) {
        this.renderGraph()
      }
    },
  },
  mounted() {
    if (this.preview.enabled && this.preview.renderData) {
      this.renderGraph()
    }
  },
  methods: {
    ...mapActions(['saveGraph']),
    renderGraph() {
      if (this.preview.enabled) {
        if (this.preview.renderData) {
          nextTick(() => {
            buildGraph(this.preview.renderData).render(this.$refs.graph)
          })
        } else {
          this.$refs.graph.textContent = ''
        }
      }
    },
  },
}
</script>
